export enum OrderHistoryEventType {
    OrderCreated = 0,
    OrderUpdated = 1,
    OrderStatusUpdated = 2,
    OrderCancelled = 3,
    OrderAddedToShipment = 4,
    OrderInvoiced = 5,
    OrderApproved = 6,
    OrderStatusUpdatedV2 = 7
}

export const OrderHistoryEventTypeMetadata = {
    '0' : {
        display: 'Order Created',
        value: 0
    },
    '1' : {
        display: 'Order Updated',
        value: 1
    },
    '2' : {
        display: 'Order Status Updated',
        value: 2
    },
    '3' : {
        display: 'Order Cancelled',
        value: 3
    },
    '4' : {
        display: 'Order Added to Shipment',
        value: 4
    },
    '5' : {
        display: 'Order Invoiced',
        value: 5
    },
    '6' : {
        display: 'Order Approved',
        value: 6
    },
    '7' : {
        display: 'Order Status Updated',
        value: 7
    }
};
